<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Dtsmart
  Author URL: http://dtsmart.vn
========================================================================================== -->


<template>
  <div class="relative" id="my-navbar-container">
    <div class="vx-navbar-wrapper" :class="classObj">
      <vs-navbar
        class="vx-navbar navbar-custom navbar-skelton rounded-10"
        :color="navbarColorLocal"
      >
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon
          class="sm:inline-flex xl:hidden cursor-pointer mr-1"
          icon="MenuIcon"
          @click.stop="showSidebar"
          v-if="afterLoginConfig && afterLoginConfig.isIn == false"
        ></feather-icon>

        <router-link
          to="/after-login"
          class="flex align-center ml-1"
          v-if="afterLoginConfig && afterLoginConfig.isIn == false"
          style="color: #626262"
        >
          <feather-icon
            svgClasses="w-6"
            class="ml-2 mr-1"
            icon="HomeIcon"
            style="transform: translateY(-1px)"
          ></feather-icon>
          <p
            class="ml-2 text-xl"
            style="text-transform: capitalize"
            :key="sidebar_key"
          >
            {{ title }}
          </p>
        </router-link>

        <template v-if="windowWidth >= 992">
          <!-- STARRED PAGES - FIRST 10 -->
          <ul class="vx-navbar__starred-pages">
            <draggable
              v-model="starredPagesLimited"
              :group="{ name: 'pinList' }"
              class="flex cursor-move"
            >
              <li
                class="starred-page"
                v-for="page in starredPagesLimited"
                :key="page.url"
              >
                <vx-tooltip :text="page.label" position="bottom" delay=".3s">
                  <feather-icon
                    svgClasses="h-6 w-6"
                    class="p-2 cursor-pointer"
                    :icon="page.labelIcon"
                    @click="$router.push(page.url).catch(() => {})"
                  />
                </vx-tooltip>
              </li>
            </draggable>
          </ul>

          <!-- STARRED PAGES MORE -->
          <div
            class="vx-navbar__starred-pages--more-dropdown"
            v-if="starredPagesMore.length"
          >
            <vs-dropdown vs-custom-content vs-trigger-click>
              <feather-icon
                icon="ChevronDownIcon"
                svgClasses="h-4 w-4"
                class="cursor-pointer p-2"
              ></feather-icon>
              <vs-dropdown-menu>
                <ul class="vx-navbar__starred-pages-more--list">
                  <draggable
                    v-model="starredPagesMore"
                    :group="{ name: 'pinList' }"
                    class="cursor-move"
                  >
                    <li
                      class="starred-page--more flex items-center cursor-pointer"
                      v-for="page in starredPagesMore"
                      :key="page.url"
                      @click="$router.push(page.url).catch(() => {})"
                    >
                      <feather-icon
                        svgClasses="h-5 w-5"
                        class="ml-2 mr-1"
                        :icon="page.labelIcon"
                      ></feather-icon>
                      <span class="px-2 pt-2 pb-1">{{ page.label }}</span>
                    </li>
                  </draggable>
                </ul>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>

          <!-- <div class="bookmark-container">
          <feather-icon icon="StarIcon" :svgClasses="['stoke-current text-warning', {'text-white': navbarColor != '#fff'}]" class="cursor-pointer p-2" @click.stop="showBookmarkPagesDropdown = !showBookmarkPagesDropdown" />
                    <div v-click-outside="outside" class="absolute bookmark-list w-1/3 xl:w-1/4 mt-4" v-if="showBookmarkPagesDropdown">
          <vx-auto-suggest :autoFocus="true" :data="navbarSearchAndPinList" @selected="selected" @actionClicked="actionClicked" inputClassses="w-full" show-action show-pinned background-overlay></vx-auto-suggest>
          </div>
          </div>-->
        </template>

        <vs-spacer />

        <!-- SEARCHBAR -->
        <!-- <div class="search-full-container w-full h-full absolute left-0" :class="{'flex': showFullSearch}" v-show="showFullSearch">
          <vx-auto-suggest
            class="w-full"
            inputClassses="w-full vs-input-no-border vs-input-no-shdow-focus"
            :autoFocus="showFullSearch"
            :data="navbarSearchAndPinList"
            icon="SearchIcon"
            placeholder="Search..."
            ref="navbarSearch"
            @closeSearchbar="showFullSearch = false"
            @selected="selected"
            background-overlay />
          <div class="absolute right-0 h-full z-50">
              <feather-icon icon="XIcon" class="px-4 cursor-pointer h-full close-search-icon" @click="showFullSearch = false"></feather-icon>
          </div>
      </div>
        <feather-icon icon="SearchIcon" @click="showFullSearch = true" class="cursor-pointer navbar-fuzzy-search mr-4"></feather-icon>-->

        <feather-icon
          icon="SearchIcon"
          class="cursor-pointer navbar-fuzzy-search mr-2"
          v-if="$route.name == 'appointment'"
          @click="openSearchAppointmentPopup"
        ></feather-icon>

        <div class="mx-3" :class="{'mr-6 pr-1': afterLoginConfig && afterLoginConfig.isIn == true}" v-if="smsCount && smsCount.sms_count_active == 1">
          <small>Balance</small>
          <p class="font-extrabold" style="margin-top: -1px;">
            {{ smsCount.sms_count ? smsCount.sms_count : 0 }} SMS
          </p>
        </div>

        <!-- USER META -->
        <div
          class="the-navbar__user-meta flex items-center"
          v-if="userInfo.name"
        >
          <vs-dropdown
            vs-custom-content
            vs-trigger-click
            class="cursor-pointer"
            style="transform: translateY(4px)"
            v-if="show_dropdown"
          >
            <div class="con-img ml-3">
              <img src="../../../assets/images/multi.svg" class="multi-app" />
            </div>
            <vs-dropdown-menu
              class="vx-navbar-dropdown dropdown-after-login-list"
              id="dropdownMenu"
            >
              <ul class="multi-app-menu-box">
                <li
                  class="multi-app-menu-item"
                  v-if="config.gocheckin_feature == 1 || config.reminder_package_active == 1"
                >
                  <a @click="selectItem('checkout')" class="multi-app-menu-a">
                    <div class="multi-app-menu-image">
                      <vx-card class="after-login-card shadow-lg mx-auto">
                        <feather-icon
                          icon="CheckSquareIcon"
                          svgClasses="stroke-current"
                          style="transform: translateY(3px)"
                        />
                      </vx-card>
                    </div>
                    <div class="multi-app-menu-text">Go Checkout</div>
                  </a>
                </li>
                <!-- <li class="multi-app-menu-item" v-if="config.appointment_feature == 1"> -->
                <li class="multi-app-menu-item">
                  <a
                    @click="selectItem('appointment')"
                    class="multi-app-menu-a"
                  >
                    <div class="multi-app-menu-image">
                      <vx-card class="after-login-card shadow-lg mx-auto">
                        <feather-icon
                          icon="CalendarIcon"
                          svgClasses="stroke-current"
                          style="transform: translateY(3px)"
                        />
                      </vx-card>
                    </div>
                    <div class="multi-app-menu-text">Go Booking</div>
                  </a>
                </li>
                <li
                  class="multi-app-menu-item"
                  v-if="config.order_feature == 1"
                >
                  <a @click="selectItem('order')" class="multi-app-menu-a">
                    <div class="multi-app-menu-image">
                      <vx-card class="after-login-card shadow-lg mx-auto">
                        <feather-icon
                          icon="ShoppingCartIcon"
                          svgClasses="stroke-current"
                          style="transform: translate(-3px, 3px)"
                        />
                      </vx-card>
                    </div>
                    <div class="multi-app-menu-text">Go Order</div>
                  </a>
                </li>
                <li class="multi-app-menu-item">
                  <a @click="selectItem('admin')" class="multi-app-menu-a">
                    <div class="multi-app-menu-image">
                      <vx-card class="after-login-card shadow-lg mx-auto">
                        <feather-icon
                          icon="UserIcon"
                          svgClasses="stroke-current"
                          style="transform: translateY(3px)"
                        />
                      </vx-card>
                    </div>
                    <div class="multi-app-menu-text">Go Check In</div>
                  </a>
                </li>
                <!-- <li class="multi-app-menu-item">
                  <a @click="selectItem('article')" class="multi-app-menu-a">
                    <div class="multi-app-menu-image">
                      <vx-card class="after-login-card shadow-lg mx-auto">
                        <feather-icon
                          icon="LayersIcon"
                          svgClasses="stroke-current"
                          style="transform: translateY(3px)"
                        />
                      </vx-card>
                    </div>
                    <div class="multi-app-menu-text">CMS</div>
                  </a>
                </li> -->
                <!-- <li class="multi-app-menu-item">
                  <a href="https://google.com" class="multi-app-menu-a">
                    <p
                      class="multi-app-menu-image"
                      style="background-image: url(//ssl.gstatic.com/gb/images/a/28a40ba7cc.png);"
                    ></p>
                    <p class="multi-app-menu-text">Go Checkout Dashboard</p>
                  </a>
                </li>-->
                <li class="multi-app-menu-item" v-if="config.pos_feature == 1">
                  <a @click="selectItem('gopos')" class="multi-app-menu-a">
                    <div class="multi-app-menu-image">
                      <vx-card class="after-login-card shadow-lg mx-auto">
                        <feather-icon
                          icon="DollarSignIcon"
                          svgClasses="stroke-current"
                          style="transform: translateY(3px)"
                        />
                      </vx-card>
                    </div>
                    <div class="multi-app-menu-text">GoPOS</div>
                  </a>
                </li>
              </ul>
            </vs-dropdown-menu>
          </vs-dropdown>
          <!-- NOTIFICATIONS -->
          <feather-icon
            v-if="afterLoginConfig && afterLoginConfig.isIn == false"
            icon="BellIcon"
            class="cursor-pointer mt-1 bell-margin-right mr-6"
            :badge="unreadAppointment + unreadSystem"
            @click="viewNotify"
          ></feather-icon>

          <feather-icon
            v-if="afterLoginConfig && afterLoginConfig.isIn == false && config.mqtt && config.mqtt.config.call_feature == 1"
            icon="PhoneIcon"
            class="cursor-pointer mt-1 bell-margin-right"
            svgClasses="h-6 w-6"
            :badge="unreadCall"
            @click="viewCallHistory"
          ></feather-icon>
          <!-- <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer" style="transform: translateY(4px)"> -->
          <!-- <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown" id="noti-dropdown-menu">

            <div class="flex justify-between notification-top text-center p-3 bg-primary text-white">
              <div class="opacity-75">App Notifications</div>
              <u class="text-sm block text-right">Mark All as Read</u>
            </div>

            <VuePerfectScrollbar ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0 mb-10" :settings="settings">
              <ul class="bordered-items">
                <li v-for="ntf in unreadNotifications" :key="ntf.index" class="flex justify-between px-4 py-4 notification cursor-pointer">
                  <div class="flex items-start">
                    <feather-icon :icon="ntf.icon" :svgClasses="[`text-${ntf.category}`, 'stroke-current mr-1 h-6 w-6']"></feather-icon>
                    <div class="mx-2">
                      <span class="font-medium block notification-title" :class="[`text-${ntf.category}`]">{{ ntf.title }}</span>
                      <small>{{ ntf.msg }}</small>
                    </div>
                  </div>
                  <small class="mt-1 whitespace-no-wrap">{{ elapsedTime(ntf.time) }}</small>
                </li>
              </ul>
            </VuePerfectScrollbar>
            <div class="checkout-footer fixed bottom-0 rounded-b-lg text-primary w-full p-2 font-semibold text-center border
                border-b-0 border-l-0 border-r-0 border-solid d-theme-border-grey-light cursor-pointer">
                <span @click="viewAll">View All Notifications</span>
            </div>
          </vs-dropdown-menu>-->
          <!-- </vs-dropdown> -->

          <div class="text-right leading-tight hidden sm:block">
            <!-- <div v-if="this.info && this.info.info"> -->
            <p class="font-semibold mb-1">{{ user_displayName }}</p>
            <!-- </div> -->
            <!-- <small>{{ StringHelper.phoneNumberFormat(userPhone) }}</small> -->
            {{ StringHelper.phoneNumberFormat(userPhone) }}
            <!-- <p><small>ID: {{businessId}}</small></p> -->
          </div>
          <vs-dropdown
            vs-custom-content
            vs-trigger-click
            class="cursor-pointer"
          >
            <div class="con-img ml-3">
              <img
                key="onlineImg"
                src="../../../assets/images/logo/newlogo.png"
                alt="user-img"
                width="40"
                height="40"
                class="rounded-full cursor-pointer block"
                style="box-shadow: 0 0 2.5px rgba(0, 0, 0, 0.5); padding: 0 2px"
              />
            </div>
            <vs-dropdown-menu
              class="vx-navbar-dropdown"
              style="width: 140px"
              id="dropdown-menu"
            >
              <vs-dropdown-item
                @click="
                  $emit('OutAfterLogin', 'setting'),
                    $router.push('/pages/app-setting').catch((err) => {})
                "
              >
                <feather-icon icon="SettingsIcon" svgClasses="w-4 h-4" />
                <span class="ml-2">Settings</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="logout">
                <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
                <span class="ml-2">Logout</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <div class="the-navbar__user-meta flex items-center" v-else>
          <!-- <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
            <div class="con-img ml-3">
              <img
                key="onlineImg"
                src="../../../assets/images/logo/newlogo.png"
                alt="user-img"
                width="40"
                height="40"
                class="rounded-full shadow-md cursor-pointer block"
              />
            </div>
            <vs-dropdown-menu class="vx-navbar-dropdown" style="width:140px;" id="dropdown-menu">
              <vs-dropdown-item @click="logout">
                <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
                <span class="ml-2">Logout</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>-->
          <div @click="logout" class="flex align-center font-bold">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </div>
        </div>
      </vs-navbar>
    </div>
    <vs-view-notify
      @Unread="unread"
      :sidebarView="sidebarView"
      @OutViewNotify="outViewNotify"
    ></vs-view-notify>
    <vs-view-call-history :callHistoryConfig="callHistoryConfig" @openCallingPopup="openCallingPopup"></vs-view-call-history>
  </div>
</template>

<script>
import VxAutoSuggest from "@/components/vx-auto-suggest/VxAutoSuggest.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import draggable from "vuedraggable";
import { StringHelper } from "../../../models/string_helper";

export default {
  name: "the-navbar",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
    afterLoginConfig: { type: Object },
    dataChange: { type: Object },
  },
  data() {
    let title = this.getType(this.$route.name);
    return {
      sidebarView: {
        isOpen: false,
      },
      callHistoryConfig: {
        isOpen: false
      },
      show: false,
      navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
      searchQuery: "",
      showFullSearch: false,
      unreadAppointment: 0,
      unreadSystem: 0,
      unreadCall: 0,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      autoFocusSearch: false,
      showBookmarkPagesDropdown: false,
      sidebar_key: 0,
      // title: this.getType(this.$route.path)
      title,
      show_dropdown: true,
      StringHelper
    };
  },
  watch: {
    sidebarView: {
      immediate: true,
      deep: true,
      handler() {
        if (this.sidebarView.isOpen) {
          this.unreadAppointment = 0;
          this.unreadSystem = 0;
        }
      },
    },
    callHistoryConfig: {
      immediate: true,
      deep: true,
      handler() {
        if(this.callHistoryConfig.isOpen) {
          this.unreadCall = 0;
        }
      }
    },
    $route() {
      if (this.showBookmarkPagesDropdown)
        this.showBookmarkPagesDropdown = false;
      this.getType(this.$route.name);
    },
    dataChange: {
      immediate: true,
      deep: true,
      handler: function () {
        if (this.dataChange) {
          this.$vs.notify({
            title: "Notification",
            text: "You have a new notification!",
            color: "warning",
            position: "top-right",
          });

          // if (!("Notification" in window)) {
          //   alert("This browser does not support desktop notification");
          //   return;
          // }
          // else if (Notification.permission === "granted") {
          //   // If it's okay let's create a notification
          //   // eslint-disable-next-line
          //   var notification = new Notification("You have a new notification!");
          //   return;
          // }

          // // Otherwise, we need to ask the user for permission
          // else if (Notification.permission !== "denied") {
          //   Notification.requestPermission().then(function (permission) {
          //       if (permission === "granted") {
          //         // eslint-disable-next-line
          //         var notification = new Notification("You have a new notification!");
          //         return ;
          //       }
          //     });
          //   }
        }
      },
    },
    afterLoginConfig: {
      immediate: true,
      deep: true,
      handler() {
        // console.log(this.afterLoginConfig);
        if (this.afterLoginConfig && this.afterLoginConfig.isIn) {
          this.show_dropdown = false;
        } else {
          this.show_dropdown = true;
        }
      },
    },
  },
  computed: {
    isLoggedIn: function () {
      // console.log(this.$store.getters["auth/isLoggedIn"])
      return this.$store.getters["auth/isLoggedIn"];
    },
    navbarColorLocal() {
      return this.$store.state.theme === "dark" ? "#10163a" : this.navbarColor;
    },
    // HELPER
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },

    // NAVBAR STYLE
    classObj() {
      if (this.afterLoginConfig && this.afterLoginConfig.isIn) {
        if (this.verticalNavMenuWidth == "default")
          return "navbar-default w-full";
        else if (this.verticalNavMenuWidth == "reduced")
          return "navbar-reduced w-full";
        else if (this.verticalNavMenuWidth) return "navbar-full w-full";
      } else {
        if (this.verticalNavMenuWidth == "default") return "navbar-default";
        else if (this.verticalNavMenuWidth == "reduced")
          return "navbar-reduced";
        else if (this.verticalNavMenuWidth) return "navbar-full";
      }
    },

    // BOOKMARK & SEARCH
    data() {
      return this.$store.state.navbarSearchAndPinList;
    },
    starredPages() {
      return this.$store.state.starredPages;
    },
    starredPagesLimited: {
      get() {
        return this.starredPages.slice(0, 10);
      },
      set(list) {
        this.$store.dispatch("arrangeStarredPagesLimited", list);
      },
    },
    starredPagesMore: {
      get() {
        return this.starredPages.slice(10);
      },
      set(list) {
        this.$store.dispatch("arrangeStarredPagesMore", list);
      },
    },

    // PROFILE
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    user_displayName() {
      return this.userInfo.name;
    },
    userPhone() {
      return this.userInfo.phone;
    },
    activeUserImg() {
      return this.$store.state.AppActiveUser.photoURL;
    },
    userInfo() {
      return this.$store.state.auth.userInfo;
    },
    info() {
      return this.$store.state.auth.info;
    },
    config() {
      return this.$store.getters["auth/config"];
    },
    businessId() {
      return localStorage.getItem("domainId");
    },

    smsCount() {
      return this.$store.getters["smsCount/smsCount"];
    },
  },
  methods: {
    openSearchAppointmentPopup() {
      this.$emit("OpenSearchAppointmentPopup");
    },
    outViewNotify(type) {
      this.$emit("OutViewNotify", type);
    },
    unread(type = null) {
      if(type == 'call') {
        this.unreadCall = 0;
      } else {
        this.unreadAppointment = 0;
        this.unreadSystem = 0;
      }
    },
    viewNotify() {
      this.sidebarView.isOpen = true;
    },
    viewCallHistory() {
      this.callHistoryConfig.isOpen = true;
    },
    openCallingPopup() {
      this.$emit("openCallingPopup");
    },
    getType(name) {
      // let path = window.location.pathname;
      if (name == "checkout" || name == "history") {
        this.title = "Go Checkout";
      } else if (name == "appointment" || name == "blocktime" || name == 'appointment-deposit') {
        this.title = "Go Booking";
      } else if (
        name == "order" ||
        name == "invoice" ||
        name == "item" ||
        name == "modifier"
      ) {
        this.title = "Go Order";
      } else if (name == "article") {
        this.title = "article";
      } else if (
        name == "timekeeping" ||
        name == "go-pos-dashboard" ||
        name == "payroll" ||
        name == "reseller" ||
        name == "batch-history" ||
        name == "go-pos-order-detail" ||
        name == "go-pos-ticket-template" ||
        name == "staff_rating" ||
        name == "giftcard" || name == "income" || name == "staff-daily-income"
      ) {
        this.title = "goPOS";
      } else {
        this.title = "Go Check in";
      }
      this.sidebar_key++;
    },
    viewAll() {
      this.$router.push("/notify");
      const dropDown = document.getElementById("noti-dropdown-menu");
      if (dropDown) {
        dropDown.style.display = "none";
      }
    },
    showFalse() {
      const dropDown = document.getElementById("dropdown-menu");
      if (dropDown) {
        dropDown.style.display = "none";
      }
    },
    showSidebar() {
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
    },
    selected(item) {
      this.$router.push(item.url).catch(() => {});
      this.showFullSearch = false;
    },
    actionClicked(item) {
      // e.stopPropogation();
      this.$store.dispatch("updateStarredPage", {
        index: item.index,
        val: !item.highlightAction,
      });
    },
    showNavbarSearch() {
      this.showFullSearch = true;
    },
    showSearchbar() {
      this.showFullSearch = true;
    },
    elapsedTime(startTime) {
      let x = new Date(startTime);
      let now = new Date();
      var timeDiff = now - x;
      timeDiff /= 1000;

      var seconds = Math.round(timeDiff);
      timeDiff = Math.floor(timeDiff / 60);

      var minutes = Math.round(timeDiff % 60);
      timeDiff = Math.floor(timeDiff / 60);

      var hours = Math.round(timeDiff % 24);
      timeDiff = Math.floor(timeDiff / 24);

      var days = Math.round(timeDiff % 365);
      timeDiff = Math.floor(timeDiff / 365);

      var years = timeDiff;

      if (years > 0) {
        return years + (years > 1 ? " Years " : " Year ") + "ago";
      } else if (days > 0) {
        return days + (days > 1 ? " Days " : " Day ") + "ago";
      } else if (hours > 0) {
        return hours + (hours > 1 ? " Hrs " : " Hour ") + "ago";
      } else if (minutes > 0) {
        return minutes + (minutes > 1 ? " Mins " : " Min ") + "ago";
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? " sec ago" : "just now");
      }

      return "Just Now";
    },
    logout() {
      // This is just for demo Purpose. If user clicks on logout -> redirect
      // this.$router.push('/pages/login').catch(() => {})
      // this.$store.dispatch("auth/logout").then(() => {
      //   // window.location.replace(history.go(-(history.length - 1)));
      //   // window.location.pathname = "/pages/login";
      //   this.$router.replace("/pages/login");
      // });
      this.$emit("logout");
    },
    outside: function () {
      this.showBookmarkPagesDropdown = false;
    },

    // Method for creating dummy notification time
    randomDate({ hr, min, sec }) {
      let date = new Date();

      if (hr) date.setHours(date.getHours() - hr);
      if (min) date.setMinutes(date.getMinutes() - min);
      if (sec) date.setSeconds(date.getSeconds() - sec);

      return date;
    },

    selectItem(type) {
      // let dropDown = document.getElementById("dropdownMenu");
      // if (dropDown) {
      //   // dropDown.style.display = "none";
      // }
      let my_container = document.getElementById("my-navbar-container");
      if (my_container) {
        my_container.click();
      }
      // console.log(this.$router.currentRoute);
      if (this.$router.currentRoute.name != type) {
        if (type == "checkout") {
          this.$router.push("/checkout");
        } else if (type == "appointment") {
          this.$router.push("/appointment");
        } else if (type == "order") {
          this.$router.push("/online-order/order");
        } else if (type == "admin" && this.$router.currentRoute.path != "/") {
          this.$router.push("/");
        } else if (type == "article") {
          this.$router.push("/article");
        } else if (
          type == "gopos" &&
          this.$router.currentRoute.path != "/go-pos/income"
        ) {
          this.$router.push("/go-pos/income");
        }
      }
    },
  },
  directives: {
    "click-outside": {
      bind: function (el, binding) {
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;
        document.addEventListener("click", handler);
      },

      unbind: function (el) {
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      },
    },
  },
  components: {
    VxAutoSuggest,
    VuePerfectScrollbar,
    draggable,
  },
  created() {
    // this.$store.dispatch("auth/GET_USER_INFO");
    let notiAppointmentList = {};
    let notiSystem = {};
    const obj = {
      page: 1,
      "per-page": 20,
    };
    this.$store.dispatch("notify/NOTIFY_APPOINTMENT", obj).then(() => {
      notiAppointmentList = this.$store.state.notify.notifyList;
      for (let i = 0; i < notiAppointmentList.items.length; i++) {
        if (notiAppointmentList.items[i].is_read == 0) {
          this.unreadAppointment++;
        }
      }
    });
    this.$store.dispatch("notify/NOTIFY_SYSTEM", obj).then(() => {
      notiSystem = this.$store.state.notify.notifySystemList;
      for (let i = 0; i < notiSystem.items.length; i++) {
        if (notiSystem.items[i].is_read == 0) {
          this.unreadSystem++;
        }
      }
    });
    this.getType(this.$route.name);
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/_variables";
#dropdown-menu {
  .vs-dropdown--menu .vs-dropdown--item .vs-dropdown--item-link {
    text-align: left;
    padding: 10px 0 10px 10px;
  }
}

.dropdown-after-login-list {
  .vs-dropdown--custom {
    border-radius: 10px;
  }
  .after-login-box {
    transition: 0.2s ease;
    cursor: pointer;
    &:hover {
      color: $primary;
      .after-login-card {
        transform: translateY(-10px);
        // box-shadow: 0px 0px 20px 1px rgba(#1ac7fc, 0.7) !important;
        // background-image: linear-gradient(
        //   to bottom,
        //   #53d7ff,
        //   #00c3ff,
        //   #00aeff,
        //   #0095ff,
        //   #2979ff
        // );
        box-shadow: 0px 0px 20px 1px rgba(#7ca9f4, 0.7) !important;
        background-image: linear-gradient(
          to bottom,
          #6a9ef4,
          #5b95f8,
          #4b8cfb,
          #3b83fd,
          #2979ff
        );
      }
    }
  }
  .after-login-card {
    transform: translateX(4px);
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    // margin-top: 30px;
    // background-image: linear-gradient(to bottom, #1ac7fc, #00b7ff, #00a5ff, #0090ff, #2979ff);
    // background-image: linear-gradient(
    //   to bottom,
    //   #1ac7fc,
    //   #00b7ff,
    //   #00a5ff,
    //   #0090ff,
    //   #2979ff
    // );
    background-image: linear-gradient(
      to bottom,
      #5392fb,
      #498cfc,
      #3f86fd,
      #347ffe,
      #2979ff
    );
    transition: 0.2s ease;
    color: #fff;
    cursor: pointer;
    svg {
      width: 30px;
      height: 30px;
    }
  }
  .multi-app-menu-box {
    padding: 17px 0 20px 0;
  }
  .multi-app-menu-item {
    padding: unset !important;
    margin: 0 6px;
  }
  .multi-app-menu-text {
    // width: 80px;
    width: 83px;
  }
}

.bell-margin-right {
  margin-right: 0.5em;
}

@media (min-width: 576px) {
  .bell-margin-right {
    margin-right: 30px;
  }
}
</style>
